import React from 'react';
import { css } from 'aphrodite';
import styles from './layout-styles';
import Sidebar from '../sidebar/sidebar';
import Header from './header';
import DIMENSIONS from '../../library/dimensions';
import { sidebarCollapseSpeed } from '../sidebar/sidebar-styles';

const LayoutView = (props) => (
  <div className={css(styles.root)}>
    <Header headerTitle={props.headerTitle} />
    <Sidebar/>
    <div style={{transition: sidebarCollapseSpeed,width: props.layout.sidebarCollapsed? DIMENSIONS.sidebarWidthCollapsed : DIMENSIONS.sidebarWidth}} />
    <div className={css(styles.content)}>
      <div style={{height: DIMENSIONS.headerHeight}} />
      {props.children}
    </div>
  </div>
);

export default LayoutView;



// WEBPACK FOOTER //
// ./src/components/layout/layout-view.js